import { useEffect } from 'react';

import { useUserAuthenticated } from '@store';
import { tokenRefreshManager } from '@utils';

export const useTokenManager = () => {
  const isAuthenticated = useUserAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      // Start periodic token checking when authenticated
      tokenRefreshManager.startPeriodicCheck();
    } else {
      // Stop checking when not authenticated
      tokenRefreshManager.stopPeriodicCheck();
    }

    // Cleanup on unmount
    return () => {
      tokenRefreshManager.stopPeriodicCheck();
    };
  }, [isAuthenticated]);

  return null;
};
